import { Component, OnInit, Input, OnChanges} from '@angular/core';
import { ICost, Cost } from '../../models/ICost';
import { FezaDataService } from '../../services/fezadata.service';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'cost-viewer',
  templateUrl: './cost-viewer.component.html',
  styleUrls: ['./cost-viewer.component.css']
})

export class CostViewerComponent implements OnInit, OnChanges {
  @Input() inputCost: ICost;
  @Input() currencyToShow: string;
  $cost: Observable<ICost>;
  @Input() label: string;
  @Input() showTemplateRateCards: boolean;

  constructor(private fezaService: FezaDataService) {

  }

  ngOnChanges() {
    this.$cost = this.fezaService.CostConversion(this.inputCost, this.currencyToShow);
  }


  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/cost-viewer/cost-viewer.component.ts